import { useEffect, useState } from 'react';
import { getJson } from '../api/client';
import { EmptyState, Spinner } from '../components/ui';
import { brl } from '../lib/format';
import styles from './screens.module.css';

interface Balancete {
  id: number;
  ano: number;
  mes: number;
  versao: number;
  resultado: number | null;
  pdfDocumentoId: number | null;
}

export function Balancetes() {
  const [itens, setItens] = useState<Balancete[] | null>(null);

  useEffect(() => {
    void getJson<{ balancetes: Balancete[] }>('/api/balancetes').then((d) =>
      setItens(d?.balancetes ?? []),
    );
  }, []);

  if (itens === null) return <Spinner />;
  if (itens.length === 0) return <EmptyState>Nenhum balancete publicado ainda.</EmptyState>;

  return (
    <ul className={styles.list}>
      {itens.map((b) => (
        <li key={b.id} className={styles.listItem} style={{ cursor: 'default' }}>
          <span>
            {String(b.mes).padStart(2, '0')}/{b.ano} · v{b.versao}
            {b.resultado != null ? ` · Resultado ${brl(b.resultado)}` : ''}
          </span>
          {b.pdfDocumentoId ? (
            <a
              href={`/api/documentos/${encodeURIComponent(b.pdfDocumentoId)}/download`}
              target="_blank"
              rel="noopener noreferrer"
            >
              ↓ PDF
            </a>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
